// frontend/src/pages/dashboards/SharedTag.jsx
// Phase 4 step 14c-3: "Shared publicly", on the dashboard list and under a
// dashboard's title, for every role, when the dashboard has a working public
// link (the server's `shared`).
import React from 'react';
import { Globe } from 'lucide-react';

export default function SharedTag() {
  return (
    <span className="inline-flex items-center gap-1 rounded-md bg-blue-500/10 px-1.5 py-0.5 text-[11px] font-medium text-blue-300 ring-1 ring-blue-500/20"
      title="Anyone with one of its links can see this dashboard">
      <Globe className="h-3 w-3" aria-hidden="true" /> Shared publicly
    </span>
  );
}
